import React from "react";
import Layout from "../../components/layout/Layout";
import { useAuth } from "../../hooks/useAuth";
import CourseLibrary from "../../components/course/CourseLibrary";

const siteMetadata = {
  title: "The Course — Designing Multi-Agent Systems",
  description:
    "Every chapter of the book as presentation slides, downloadable as PDF. Chapters 1 and 2 are free.",
  author: "Victor Dibia",
  image: "/images/og-service.png",
  keywords: "multi-agent systems course, agent engineering slides, lecture decks",
  twitterUsername: "@designingwithml",
};

const CoursePage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  return (
    <Layout meta={siteMetadata} title="Course" link={"/course"}>
      <CourseLibrary
        user={isAuthenticated && user ? user : null}
        authLoading={isLoading}
      />
    </Layout>
  );
};

export default CoursePage;
